import { useAppSelector } from "../hooks/storeHooks";
import { selectMetrics } from "../store/selectors/metricSelectors";
import { CommonDefectsTiles } from "../components/DashboardTiles/CommonDefectsTiles";
import { selectSelectedList } from "../store/selectors/userSelectors";
import { useTranslation } from "react-i18next";
import { GradeTiles } from "../components/DashboardTiles/GradeTiles";
import { ImprovedGradeTiles } from "../components/DashboardTiles/ImprovedGradeTiles";
import { CampaignTiles } from "../components/DashboardTiles/CampaignTiles";
import { useFlags } from "launchdarkly-react-client-sdk";
import { RecurringDefectsTiles } from "../components/DashboardTiles/RecurringDefectsTiles";
import { SubgradeTiles } from "../components/DashboardTiles/SubgradeTiles";
import { PscRiskTiles } from "../components/DashboardTiles/PscRiskTiles";

const Dashboard = () => {
    const { data, loading } = useAppSelector(selectMetrics);
    const selectedList = useAppSelector(selectSelectedList);

    const { t } = useTranslation("locale");

    const { releaseRecurringDefects, releasePscMappingCharts } = useFlags();

    const showMonitoringTiles = selectedList?.type === "general";

	if (!loading && !data) {
        return (
            <div className="flex justify-content-center">
                <p>{t("dashboard.noDashboardAvailable")}</p>
            </div>
        );
    }

    return (
        <div className="grid flex-grow-1">
            <GradeTiles metrics={data?.grade} loading={loading} />
            <ImprovedGradeTiles metrics={data?.grade} loading={loading} />
            <SubgradeTiles metrics={data?.subgrade_metrics} loading={loading} />
            {showMonitoringTiles && (
                <>
                    <CommonDefectsTiles metrics={data?.common_defects} loading={loading} />
                    {releaseRecurringDefects && (
                        <RecurringDefectsTiles metrics={data?.recurring_defects} loading={loading} maxItems={5} />
                    )}
                    {releasePscMappingCharts && <PscRiskTiles />}
                </>
            )}
            <CampaignTiles 
                latestInspection={data?.inspection?.latest}
                campaignMetrics={data?.campaign_metrics}
                loading={loading}
            />
        </div>
    );
};

export default Dashboard;
